export default __webpack_public_path__ + "static/media/home-business-parallax-bg.1b22bfc5.jpg";